export default __webpack_public_path__ + "static/6610-e3cb7bec4106c30f38d43e99932c675c.jpg";